// c:/xampp/htdocs/miners-market-main/components/forms/MineSaleForm.js

import AccordionSection from '../AccordionSection.jsx';
import MediaManager from './MediaManager.jsx';

function MineSaleForm({ formData, onFormChange, openSection, onToggleSection }) {
    return (
        <div className="space-y-2">
            <AccordionSection title="1. Mine Sale Details" id="mineSaleDetails" openSection={openSection} onToggle={onToggleSection}>
                <div>
                    <label className="block text-sm font-medium text-gray-700">Mine Name*</label>
                    <input type="text" name="name" value={formData.name || ''} onChange={onFormChange} required className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" />
                </div>
                <div className="grid md:grid-cols-2 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Location*</label>
                        <input type="text" name="location" value={formData.location || ''} onChange={onFormChange} required className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Price (R)*</label>
                        <input type="text" name="price" value={formData.price ?? ''} onChange={onFormChange} required className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" />
                    </div>
                </div>
            </AccordionSection>

            <AccordionSection title="2. Images" id="images" openSection={openSection} onToggle={onToggleSection}>
                <MediaManager formData={formData} onFormChange={onFormChange} />
            </AccordionSection>

            <AccordionSection title="3. Contact Information" id="contactInfo" openSection={openSection} onToggle={onToggleSection}>
                <div className="grid md:grid-cols-2 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Sales Contact Name</label>
                        <input type="text" name="sales_contact_name" value={formData.sales_contact_name || ''} onChange={onFormChange} className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Sales Contact Phone</label>
                        <input type="tel" name="sales_contact_phone" value={formData.sales_contact_phone || ''} onChange={onFormChange} className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" />
                    </div>
                </div>
                <div className="grid md:grid-cols-2 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Sales Contact Email</label>
                        <input type="email" name="sales_contact_email" value={formData.sales_contact_email || ''} onChange={onFormChange} className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Company Name & Address</label>
                        <input type="text" name="company_name_address" value={formData.company_name_address || ''} onChange={onFormChange} className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" />
                    </div>
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700">Support Contact Details</label>
                    <textarea name="support_contact_details" value={formData.support_contact_details || ''} onChange={onFormChange} rows="3" className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" placeholder="e.g., Technical support line, email, or website"></textarea>
                </div>
            </AccordionSection>
        </div>
    );
}

export default MineSaleForm;
